

export class AppTypedStoreConfig {
	// TODO Dayal This is temporary, as in view-data-factory, for the registerAppStoreConfig method, we have to support the typed config classes,
	// such as "PacStoreConfig". However, this is in the app, so can't import it, hence as a temp solution, we can have an empty class which gets extended
	// from all the new typed classes and therefore can be used in this lib. Possibly going forward, we could even put the default configs for all apps in here.
}
